var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftBoxesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_9216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5152 28.4531L0.200806 12.5863L1.21881 5.84344L16.1842 21.9656L14.5152 28.4531Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5153 28.4531L37.7286 22.359L40 15.9129L16.1842 21.9656L14.5153 28.4531Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9197 15.0019L24.3075 3L2.46539 5.40176L16.759 20.4127L38.9197 15.0019Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2036 30.4062L1.97363 17.2311C1.8852 17.1461 1.77565 17.086 1.65623 17.0571C1.53682 17.0282 1.41185 17.0314 1.29412 17.0666C1.1764 17.1017 1.07015 17.1674 0.986327 17.257C0.902503 17.3465 0.844112 17.4567 0.817128 17.5762L0.0415078 22.0208C-0.0680313 22.6633 -0.0335589 23.3219 0.142444 23.9496C0.318447 24.5772 0.631599 25.1583 1.05949 25.6511L10.9764 37.0801C11.0817 37.2323 11.2049 37.3713 11.3435 37.4942L11.4404 37.5701C11.8514 37.9036 12.3647 38.0863 12.8947 38.0877C13.0791 38.086 13.2627 38.0629 13.4418 38.0187V38.0187L31.3088 32.8149C31.7674 32.6901 32.1876 32.4539 32.5321 32.1275C32.8765 31.8011 33.1344 31.3947 33.2825 30.9446L35.1454 25.0989L14.2036 30.4062Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_9216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBoxesIcon);
export default __webpack_public_path__ + "static/media/GiftBoxesIcon.65ac986906e4e7553f9f93d11e64b2c9.svg";
export { ForwardRef as ReactComponent };